import Model from './RecipeInstructionsStep.schema';

export default class RecipeInstructionsStep extends Model {}
